export default __webpack_public_path__ + "static/media/3.2.aab6fb8a.webm";